import { render, staticRenderFns } from "./TriggerReleaseEmails.vue?vue&type=template&id=8bf0e17c"
import script from "./TriggerReleaseEmails.vue?vue&type=script&lang=js"
export * from "./TriggerReleaseEmails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports